const EbComsView = () =>
  import(
    /* webpackChunkName: "ebComs_view" */
    "./View"
  );

export default EbComsView;
